import React, { Component } from "react";
import { Button, DropdownButton, Glyphicon, MenuItem} from "react-bootstrap";
import "../../css/modal/ModalSaveBlock.css";

export default class DropdownBlockCategories extends React.Component {

    constructor(props) {
        super(props);
        this.state = { category: 'Select' };
    }

    onSelect(event) {
        var id       = event[0];
        var category = event[1];
        this.setState({
            id:    id,
            category: category
        });

        this.props.getBlockCategory(id); // update id in parent
    }

    render() {
        return (
            <DropdownButton id="Category"
                            onSelect  = {(event) => this.onSelect(event)}
                            title     = {this.state.category}
                            style={{fontSize:18}}
                            className = "dropdownBlockCategories"
                        >
                    <MenuItem eventKey={["1", "Foam Roll"]} className="" style={{fontSize:18}}>Foam Roll</MenuItem>
                    <MenuItem eventKey={["2", "Correctives"]} className="" style={{fontSize:18}}>Correctives</MenuItem>
                    <MenuItem eventKey={["3", "Prep"]} className="" style={{fontSize:18}}>Prep</MenuItem>
                    <MenuItem eventKey={["4", "S.L.A.T.E. (Speed. Landing. Acceleration. Tempo. Explosion)"]} className="" style={{fontSize:18}}>S.L.A.T.E. (Speed. Landing. Acceleration. Tempo. Explosion)</MenuItem>
                    <MenuItem eventKey={["5", "Strength"]} className="" style={{fontSize:18}}>Strength</MenuItem>
                    <MenuItem eventKey={["6", "ESD"]} className="" style={{fontSize:18}}>ESD</MenuItem>

             </DropdownButton>
         );
     }

}



// WEBPACK FOOTER //
// ./src/components/dropdown/DropdownBlockCategories.js